import * as d3 from 'd3'
import { isLeagueKey } from '../key-parsing.ts'

const colorStore: Record<string, string> = {}

// Players get tableau 0-4; league gets 6-9 then 5 (yellow last — poor text legibility)
const PLAYER_PALETTE = [3, 1, 2, 4, 0].map((i) => d3.schemeTableau10[i])
const LEAGUE_PALETTE = [6, 7, 8, 9, 5].map((i) => d3.schemeTableau10[i])

function getPalette(uniqueId: string): string[] {
    return isLeagueKey(uniqueId) ? LEAGUE_PALETTE : PLAYER_PALETTE
}

export default function getDistributionColor(uniqueId: string) {
    if (colorStore[uniqueId]) {
        return colorStore[uniqueId]
    }

    const palette = getPalette(uniqueId)
    const usedColors = new Set(
        Object.entries(colorStore)
            .filter(([key]) => isLeagueKey(key) === isLeagueKey(uniqueId))
            .map(([, color]) => color)
    )

    const hex = palette.find((c) => !usedColors.has(c))
    if (hex) {
        colorStore[uniqueId] = hex
        return hex
    }

    return '#666'

    // const hex = d3.schemeTableau10[idx % 10]
    // const color = d3.color(hex)
    // if (!color) {
    //     return '#666'
    // }

    // color.opacity = 0.8

    // return String(color)
}

// I don't like this, but it's sort of clever
export function removeColorByKey(key: string) {
    delete colorStore[key]
}

export function removeColorsByPrefix(prefix: string) {
    Object.keys(colorStore).forEach((key) => {
        if (key.startsWith(prefix)) {
            delete colorStore[key]
        }
    })
}
